"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRemToPx = void 0;
const react_1 = require("react");
const config = { attributes: true, attributeFilter: ['style', 'class', 'id'] };
const getRemValue = () => (typeof window !== 'undefined' &&
    Number.parseInt(window
        .getComputedStyle(document.documentElement)
        .getPropertyValue('font-size'))) ||
    16;
function useRemToPx() {
    const [pxValue, setPxValue] = (0, react_1.useState)(getRemValue);
    const remToPx = (0, react_1.useCallback)((rem) => rem * pxValue, [pxValue]);
    const handleChange = (0, react_1.useCallback)(() => {
        const nextValue = getRemValue();
        if (nextValue !== pxValue) {
            setPxValue(nextValue);
        }
    }, [pxValue]);
    const handleAttributesChange = (0, react_1.useCallback)((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes') {
                handleChange();
            }
        }
    }, [handleChange]);
    (0, react_1.useEffect)(() => {
        let observer;
        window.addEventListener('resize', handleChange);
        if (MutationObserver) {
            observer = new MutationObserver(handleAttributesChange);
            observer.observe(document.documentElement, config);
        }
        return () => {
            window.removeEventListener('resize', handleChange);
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [handleChange, handleAttributesChange]);
    return remToPx;
}
exports.useRemToPx = useRemToPx;
